import PropTypes from 'prop-types';
import React from 'react';

import Button from '../../shared/Button/Button';
import CloseIcon from './CloseIcon';
import styles from './SendConfirmationModal.module.scss';

// eslint-disable-next-line react/prop-types
const SendConfirmationModal = ({ closeModal, transition, theme }) => {
  const closeAndRedirect = () => {
    closeModal();
    transition('back', { defaultSelected: 'Sent', showCompose: false });
  };
  return (
    <div className={styles['modal-body']} id="send-modal">
      <a
        alt="close"
        className={styles['close-icon']}
        id="close-icon"
        onClick={closeAndRedirect}
      >
        <CloseIcon theme={theme}></CloseIcon>
      </a>
      <div className={styles.header}>Your Secure Message Has Been Sent</div>
      <div className={styles.body}>
        <p>
          A representative will respond to your message via secure email{' '}
          <strong>generally within 2 to 3 business days</strong>.{' '}
        </p>
        <p>
          An email alert will be sent to your email address on file when a
          response is available.
        </p>
      </div>
      <Button
        className={`${styles['link-button']} close-modal ${styles['branded-button']}`}
        onClick={closeAndRedirect}
      >
        Okay
      </Button>
    </div>
  );
};

SendConfirmationModal.propTypes = {
  closeModal: PropTypes.func,
  transition: PropTypes.func
};

export default SendConfirmationModal;
